import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=4012b7e0&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=4012b7e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012b7e0",
  null
  
)

export default component.exports